import { randomNumberInRange } from '@shared/utils';
import React from 'react';

export const useRandomInterval = (callback: () => void, minDelay?: number, maxDelay?: number) => {
  const timeoutId = React.useRef<number>();
  const savedCallback = React.useRef(callback);

  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    const isEnabled = typeof minDelay === 'number' && typeof maxDelay === 'number';

    if (isEnabled) {
      const handleTick = () => {
        const nextTickAt = randomNumberInRange(minDelay, maxDelay);

        timeoutId.current = window.setTimeout(() => {
          savedCallback.current();
          handleTick();
        }, nextTickAt);
      };

      handleTick();
    }

    return () => window.clearTimeout(timeoutId.current);
  }, [minDelay, maxDelay]);

  return React.useCallback(function () {
    window.clearTimeout(timeoutId.current);
  }, []);
};
